module.exports = __webpack_public_path__ + "media/images/announceGroup__textBg-ad08b846188ea7ece9d2bffef7019927.png";